import { IStudent } from "features/Students";
import { API, IResponse, onDayDelay } from "./API";

export interface IUpdateStudentRequest {
  _id: number;
  _classId: number;
  _fullName: string;
  _studentSchoolUid: string;
}
export interface IFetchStudentsEntity {
  _avatarUrl: null | string;
  _classId: number;
  _className: string;
  _deepLinkHome: string;
  _dob: null | string;
  _gender: number;
  _gradeId: number;
  _gradeName: string;
  _id: number;
  _name: string;
  _parent: null | string | number;
  _pin: null | string | number;
  _studentSchoolUid: null | string;
  _studentUUIDCode: string;
  _emailAddress: string;
}

interface IFetchStudentsResponse extends IResponse {
  _entity: IFetchStudentsEntity[];
}

interface IInvalidRecordEntity {
  _fullName: string;
  _emailAddress: string;
  _studentSchoolUid: string;
  _classId: string;
  _errors: number[];
}
interface IAddStudentbyFileResponse extends IResponse {
  _entity: IInvalidRecordEntity[];
}

const studentsServices = API.injectEndpoints({
  endpoints(build) {
    return {
      fetchStudents: build.query<IFetchStudentsResponse, string>({
        query(classId) {
          return `hod/class/${classId}/student`;
        },
        providesTags: ["Students"],
        keepUnusedDataFor: onDayDelay,
      }),
      addStudent: build.mutation<IResponse, Partial<IStudent>[]>({
        query(students) {
          return {
            url: `hod/student`,
            method: "POST",
            body: students.map((student) => ({
              _classId: student.classId,
              _fullName: student.name,
              _studentSchoolUid: student.studentId,
              _emailAddress: student.email,
            })),
          };
        },
        invalidatesTags: ["Students", "Teachers", "Classes"],
      }),
      addStudentByFile: build.mutation<
        IAddStudentbyFileResponse,
        Partial<IStudent>[]
      >({
        query(students) {
          return {
            url: `hod/student/upload`,
            method: "POST",
            body: students.map((student) => ({
              _classId: student.classId,
              _fullName: student.name,
              _studentSchoolUid: student.studentId,
              _emailAddress: student.email,
            })),
          };
        },
        invalidatesTags: ["Students", "Teachers", "Classes"],
      }),
      updateStudent: build.mutation<IResponse, IUpdateStudentRequest>({
        query(data) {
          return {
            url: `hod/student`,
            method: "PUT",
            body: data,
          };
        },
        invalidatesTags: ["Students"],
      }),
      deleteStudent: build.mutation<IResponse, number>({
        query(studentId) {
          return {
            url: `hod/student/${studentId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Students", "Teachers", "Classes"],
      }),
      deleteStudentList: build.mutation<IResponse, number[]>({
        query(studentIds) {
          return {
            url: `hod/student`,
            method: "DELETE",
            body: studentIds,
          };
        },
        invalidatesTags: ["Students", "Teachers", "Classes"],
      }),
    };
  },
});

export const {
  useFetchStudentsQuery,
  useAddStudentMutation,
  useUpdateStudentMutation,
  useDeleteStudentMutation,
  useAddStudentByFileMutation,
  useDeleteStudentListMutation,
} = studentsServices;
